export const haversineDistance = (coords1, coords2, isMiles) => {
    const toRad = (x) => x * Math.PI / 180;

    const lon1 = coords1.lng;
    const lat1 = coords1.lat;

    const lon2 = coords2.lng;
    const lat2 = coords2.lat;

    const R = 6371; // km

    const x1 = lat2 - lat1;
    const dLat = toRad(x1);
    const x2 = lon2 - lon1;
    const dLon = toRad(x2)
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = R * c;

    if (isMiles) {
        d /= 1.60934;
    }

    return d;
}

export const toDegreesMinutesAndSeconds = (coordinate) => {
    let absolute = Math.abs(coordinate);
    let degrees = Math.floor(absolute);
    let minutesNotTruncated = (absolute - degrees) * 60;
    let minutes = Math.floor(minutesNotTruncated);
    let seconds = Math.floor((minutesNotTruncated - minutes) * 60);

    return `${degrees}°${minutes}'${seconds}"`;
}

export const convertDMS = (lat, lng) => {
    let latitude = toDegreesMinutesAndSeconds(lat);
    let latitudeCardinal = lat >= 0 ? "N" : "S";

    let longitude = toDegreesMinutesAndSeconds(lng);
    let longitudeCardinal = lng >= 0 ? "E" : "W";

    return latitude + " " + latitudeCardinal + "\n" + longitude + " " + longitudeCardinal;
}
